import z from "zod";

export const packageCodeSchema =  z.object({
  code: z
    .string()
    .min(1, "Code is required")
    .refine((val) => !/\s/.test(val), {
      message: "Code must not contain whitespace",
    }),
});